


import { useDispatch, useSelector } from "react-redux"
import styled from "styled-components"
import { useEffect, useState } from "react"
import { useLocation } from "react-router-dom"
import { useScrollLock } from "../../../hooks/useScrollLock"
import { handleActiveSelect } from "../../../features/layout/layoutSlice"
import { showModal } from "../../../features/modal/modalSlice"
import PageTopTitle from "../../shared/PageTopTitle"
import Btn from "../../shared/button/Btn"
import InputSide from "../../loadUpdate/mainSides/inputside/InputSide"
import MapSide from "../../loadUpdate/mainSides/mapSide/MapSide"
import updateReplicator from "../../../helper/load/updateReplicator"
import { getAracTypes } from "../../../features/adminSett/adminSettSlice"
import { setAracData, setPaymentData, setRoute, setYukData, setPaketlemeData, setRouteDistance, setUpdatedItemPublishType } from "../../../features/updateLoad/updateLoadSlice"
import 'moment/locale/tr';


const Container = styled.div`
    position: fixed;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    background-color: rgba(0,0,0,0.6);
    display: flex;
    justify-content: center;
    align-items: center;
    z-index: 26;

    .modal{
        width: 1500px;
        height: auto;
        color: ${({ theme }) => theme.mainTextColor};
        background-color: ${({ theme }) => theme.mainBgColor};
        padding-top: 20px;
        border-radius: 10px;
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;

        .content{
            width: 100%;
            display: flex;
            flex-direction: column;
            height: 650px;
            overflow: auto;
            padding: 40px;

            .top-container{
                width: 100%;
            }
            
            .side-container{
                width: 100%;
                display: flex;
                gap: 40px;
            }
        
        }

        .btn-container{
            width: 100%;
            height: 70px;
            margin: 0 40px;
            gap: 15px;
            display: flex;
            justify-content: center;
            align-items: center;
            border-top: 1px solid ${({theme}) => theme.mainBorderColor};
            
        }
    }
`

const yayinlamaSecenekleri = [
    {
        id:1,
        text: "Herkese Yayınla",
        description:"Tüm KAMYOON üyelerine yayınlanacaktır. Tüm üyeler teklif verebilecektir."
    },
    {
        id:2,
        text: "Önce Yük Arayan Araçlarıma - Sonra Herkese Yayınla",
        description:"Önce sürücülerime yayınlanacak; 3 saat sonra tüm KAMYOON üyelerine yayınlanacaktır."
    },
    {
        id:3,
        text: "Yük Arayan Araçlarıma Yayınla",
        description:"Sadece kendi sürücülerime yayınlanacak ve sadece kendi sürücülerim teklif verebilecektir."
    },
    {
        id:4,
        text: "İş Listemde Kalsın",
        description:"Yayınlanmaz. Sadece kendi iş listenizde kalır. Teklif toplayamazsınız. “Herkese Yayınla” seçeneğini tercih etmeniz önerilir."
    }
]

const UpdateLoadModal = () => {
    
    const dispatch = useDispatch()
    const location = useLocation()

    const {modalLocation } = useSelector(state => state.modal)
    const { lockScroll, unlockScroll } = useScrollLock();
    const { loadItemData } = useSelector(state => state.loadList)

    //! bu modal açıldığnda ekran ı lock lamak için
    useEffect(() => {
        lockScroll()
        return () => {
            unlockScroll()
        }
    }, [lockScroll, unlockScroll])
    
    //! bu başka bir sayfaya geçildiğinde modal ı kapatmak için
    useEffect(() => {
        if (location.pathname !== modalLocation) {
            dispatch(showModal(null))
        }
    }, [dispatch, location.pathname, modalLocation])

    useEffect(() => {
        dispatch(getAracTypes())
    },[])

    useEffect(()=> {
        const { paymentDataResolver, aracDataResolver, yukDataResolver, routeResolver, paketlemeDataResolver} = updateReplicator(loadItemData) 
        
        dispatch(setAracData(aracDataResolver))
        dispatch(setYukData(yukDataResolver))
        dispatch(setPaymentData(paymentDataResolver))
        dispatch(setRoute(routeResolver))
        dispatch(setPaketlemeData(paketlemeDataResolver))
        dispatch(setRouteDistance(loadItemData.distance))

        dispatch(setUpdatedItemPublishType(yayinlamaSecenekleri?.find(item => item.id === loadItemData.publishingTypeId)))
    },[])
      


    const handleClick = () => {
        

       
        dispatch(showModal("loadUpdateYayinlamaSecenekleri"))

    }


  return (
<Container>
        <div className="modal"  onClick={(e)=> {e.stopPropagation(); dispatch(handleActiveSelect(null))}}>
            <PageTopTitle title={"Yükü Güncelle"}/>
            <div className="content">
            <div className="top-container"> {/* burası ileride üste birşey eklenirse diye  */} </div>
            <div className="side-container">
                <InputSide/>
                <MapSide/>
            </div>
            </div>
            <div className="btn-container">
                <Btn bgColor="#fff" color="#E85546" width={"220px"} handleClick={() => handleClick()}>Yükü Güncelle</Btn>
                <Btn bgColor="#fff" color="#E85546" width={"220px"} handleClick={() => dispatch(showModal(null))}>Vazgeç</Btn>
            </div>
        </div>
    </Container>
  )
}

export default UpdateLoadModal